import { useState } from "react";
import { toast } from "sonner";
import { CalendarClock, Loader2 } from "lucide-react";
import { api, formatApiErrorDetail } from "@/lib/api";
import { Dialog, DialogContent, DialogHeader, DialogTitle, DialogDescription } from "@/components/ui/dialog";
import { Button } from "@/components/ui/button";

export const shouldRemindCancel = (biz) => {
  const u = biz?.cancel_reminder_until;
  return u !== "never" && !(u && new Date(u) > new Date());
};

const OPTIONS = [[1, "En 1 semana"], [2, "En 2 semanas"], [4, "En 4 semanas"]];

export function CancelReminderDialog({ open, hours, onClose, onSnoozed }) {
  const [busy, setBusy] = useState(null);
  const snooze = async (weeks) => {
    setBusy(weeks);
    try {
      await api.put("/business/cancel-reminder", { weeks });
      toast.success(weeks ? `Te lo recordaremos en ${weeks} semana${weeks > 1 ? "s" : ""}` : "No volveremos a mostrar este aviso");
      onSnoozed?.(); onClose();
    } catch (e) { toast.error(formatApiErrorDetail(e.response?.data?.detail)); }
    finally { setBusy(null); }
  };
  return (
    <Dialog open={open} onOpenChange={(o) => !o && onClose()}>
      <DialogContent className="max-w-md" data-testid="cancel-reminder-dialog">
        <DialogHeader>
          <span className="grid place-items-center w-12 h-12 rounded-full bg-primary/10 text-primary mb-1"><CalendarClock className="w-6 h-6" /></span>
          <DialogTitle>¡Tu taller ya está creado!</DialogTitle>
          <DialogDescription className="text-base text-foreground/80 leading-relaxed" data-testid="cancel-reminder-text">
            Te recordamos que tus alumnos pueden cancelar con <strong>{hours} horas</strong> de anticipación, tal como lo definiste en Configuración. ¿Sigue siendo el plazo que quieres?
          </DialogDescription>
        </DialogHeader>
        <div className="space-y-3">
          <Button className="w-full" onClick={onClose} data-testid="cancel-reminder-ok">Entendido</Button>
          <div>
            <p className="text-xs text-muted-foreground mb-1.5">Recordármelo más tarde</p>
            <div className="grid grid-cols-3 gap-2">
              {OPTIONS.map(([w, l]) => (
                <Button key={w} variant="outline" size="sm" disabled={busy !== null} onClick={() => snooze(w)} data-testid={`cancel-reminder-snooze-${w}`}>
                  {busy === w ? <Loader2 className="w-4 h-4 animate-spin" /> : l}
                </Button>
              ))}
            </div>
          </div>
          <Button variant="ghost" size="sm" className="w-full text-muted-foreground" disabled={busy !== null} onClick={() => snooze(0)} data-testid="cancel-reminder-never">
            No mostrar más
          </Button>
        </div>
      </DialogContent>
    </Dialog>
  );
}
